import { NotifyHelper } from "../../../helpers/toast";
import { objDotDangKyPhamViDefine } from "../../action-types/thuc-don/IFoDotDangKyPhamViActionTypes";
import { generateActionForKey, generateActions } from "../generateActions";

export const foDotDangKyPhamViActions = {
    ...generateActions(objDotDangKyPhamViDefine, "DOT_DANG_KY_PHAM_VI"),
    ...generateActionForKey(objDotDangKyPhamViDefine, "DOT_DANG_KY_PHAM_VI",
        "LOAD_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objDotDangKyPhamViDefine, "DOT_DANG_KY_PHAM_VI",
        "LOAD_BY_DOT_DANG_KY_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objDotDangKyPhamViDefine, "DOT_DANG_KY_PHAM_VI",
        "LOAD_BY_TRUONG_ERROR", (m: any) => NotifyHelper.Error(m))
};
